'use strict';
const angular = require('angular');

export class bulletinPropertyListComponent {
  constructor(BulletinService) {
    'ngInject';
    BulletinService.queryProperty(data => {
      this.data = data;
    }, err => {
      console.log('Could not retrieve property bulletin board posts from server');
    });
  }
}

export default angular.module('conduuApp.bulletinPropertyList', [])
  .component('bulletinPropertyList', {
    template: require('./bulletin-property-list.html'),
    bindings: {
      url: '@'
      //message: '<'
    },
    controller: bulletinPropertyListComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/bulletin/property-list/bulletin-property-list.component.js